module.exports = __webpack_public_path__ + "img/finland-male.789d2a81.png";